import { render, staticRenderFns } from "./ride-report.vue?vue&type=template&id=477d5da4&"
import script from "./ride-report.vue?vue&type=script&lang=js&"
export * from "./ride-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports